import { render } from "./ProgramReviewers.vue?vue&type=template&id=555b07a4"
import script from "./ProgramReviewers.vue?vue&type=script&lang=ts"
export * from "./ProgramReviewers.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./ProgramReviewers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script